<template>
    <div class="dv5-main" @click="redir()">
        <img class="background" :alt="view.title" :src="`${imgPath}`">
        <div class="dv5-content">
            <h3 class="title">{{ view.title }}</h3>
            <h3 class="subtitle">{{ view.subtitle }}</h3>
            <h3 class="description">{{ view.description }}</h3>
        </div>
    </div>
</template>

<script>
export default {
    name: 'dv5-slide-component',
    props: {
        view: {
            type: Object,
            default: function () {
                return {
                }
            }
        }
    },
    data() {
        return {
            windowWidth: window.innerWidth,
            imgPath: null
        }
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        })
        this.getImgPathFromSize()
        if (this.view.action_link != null && this.view.action_link !=  '') {
            $('.dv5-main').css('cursor', 'pointer')
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
    methods: {
        onResize() {
            this.windowWidth = window.innerWidth
            this.getImgPathFromSize()
        },
        getImgPathFromSize() {
            if (!this.view.only_one_image) {
                if (this.windowWidth > 1023 && this.windowWidth < 1266) {
                    this.imgPath = this.view.image_link + this.view.resolutions['1024']
                } else if (this.windowWidth >= 1266 && this.windowWidth < 1366) {
                    this.imgPath = this.view.image_link + this.view.resolutions['1266']
                } else if (this.windowWidth >= 1366 && this.windowWidth < 1920) {
                    this.imgPath = this.view.image_link + this.view.resolutions['1366']
                } else if (this.windowWidth >= 1920 && this.windowWidth < 2400) {
                    this.imgPath = this.view.image_link + this.view.resolutions['1920']
                } else {
                    this.imgPath = this.view.image_link + this.view.resolutions['2400']
                }
            } else {
                this.imgPath = this.view.image_link + this.view.image
            }

        },
        redir() {
            if (this.view.action_link != null && this.view.action_link !=  '') {
                window.open(this.view.action_link, '_blank')
            }
        }
    },
}
</script>

<style scoped lang="scss">
@import '../../../../scss/extras/_variables';

.dv5-main{
    width: 100%;
    height: calc(99.6vh - 2rem);
    display: flex;
    justify-content: center;
    position: relative;
    background-color: #0e0e0e;

    .background{
        top: 0;
        background-size: cover;
        height: 100%;
        width: 100%;
        overflow: hidden;
        position: absolute;
        //object-fit: cover;
    }
    .dv5-content{
        height: 200px;
        width: 80%;
        margin-top: 6%;

        position: absolute;

        .title{
            font: $dv5-font2;
            font-size: 3.3rem;
            font-weight: 1000;
            color: $dv5-color4;
            margin-bottom: .5em;
        }
        .subtitle{
            font: $dv5-font2;
            font-size: 2.2rem;
            font-weight: 500;
            color: $dv5-color4;
            margin: .5em 0 .5em 0;
        }
        .description{
            font: $dv5-font2;
            font-size: 1.3rem;
            color: $dv5-color4;
            margin: .5em 0 .5em 0;
        }
    }
}

</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/auth/SlideComponent.vue